import { MarkdownService } from '../../markdown/markdown.service';
import {
  AbstractControl,
  AsyncValidatorFn,
  ValidationErrors
} from '@angular/forms';
import { Observable, of } from 'rxjs';

export class CreatePostValidator {
  static maxPost(
    markdown: MarkdownService,
    maxCount: number
  ): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control && control?.value.isEmpty) {
        return of(null);
      }

      const convertedData = markdown.convert(control.value);
      if (convertedData.length > maxCount)
        return of({
          maxPost: true
        });
      return of(null);
    };
  }

  static minPost(
    markdown: MarkdownService,
    minCount: number
  ): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control) {
        return of(null);
      }

      const convertedData = markdown.convert(control.value);
      if (convertedData.length < minCount)
        return of({
          minPost: true
        });
      return of(null);
    };
  }
}
